// Aerator Project - FMEA Seed Data with Change History
// Compatible with DFR-App-Demo - Includes iteration tracking

export const fmeaSeedData = [
    {
        id: 'FMEA-001',
        function: 'Enclosure Integrity',
        itemFunction: 'Provide structural support',
        requirement: 'Withstand drop from 1m onto concrete',
        failureMode: 'Housing cracks on impact',
        effects: 'Internal components exposed, potential user injury, loss of function',
        S: 8,
        O: 3,
        D: 6,
        RPN: 144,
        preventionControls: ['C-PREV-001'],
        detectionControls: ['C-DET-001'],
        status: 'active',
        projectName: 'Aerator Pro',
        classification: 'SC',
        epochId: 17,
        notes: 'Mitigated via high-impact ABS material spec',
        changeHistory: [
            {
                timestamp: '2025-09-15T10:30:00Z',
                user: 'WK',
                field: 'Material Selection',
                oldValue: 'Standard ABS',
                newValue: 'High-Impact ABS',
                comment: 'Upgraded to meet drop test requirements'
            },
            {
                timestamp: '2025-10-01T14:20:00Z',
                user: 'JS',
                field: 'O',
                oldValue: 5,
                newValue: 3,
                comment: 'Reduced occurrence after material upgrade and testing'
            }
        ]
    },
    {
        id: 'FMEA-002',
        function: 'Enclosure Integrity',
        itemFunction: 'Maintain dimensional stability',
        requirement: 'Parts must fit together over product lifetime',
        failureMode: 'Housing warps over time due to thermal cycling',
        effects: 'Parts misalign, switch sticks, battery door fails',
        S: 6,
        O: 2,
        D: 7,
        RPN: 84,
        preventionControls: ['C-PREV-001', 'C-PREV-002'],
        detectionControls: ['C-DET-002'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'Low occurrence confirmed via ALT testing',
        changeHistory: [
            {
                timestamp: '2025-09-20T09:15:00Z',
                user: 'MC',
                field: 'Initial FMEA',
                oldValue: 'N/A',
                newValue: 'Created',
                comment: 'Initial risk assessment'
            }
        ]
    },
    {
        id: 'FMEA-003',
        function: 'Electrical Distribution',
        itemFunction: 'Conduct current from battery to motor',
        requirement: 'Low resistance electrical path (<0.1Ω)',
        failureMode: 'Wire breaks due to vibration fatigue',
        effects: 'Intermittent or complete loss of power',
        S: 9,
        O: 2,
        D: 4,
        RPN: 72,
        preventionControls: ['C-PREV-003'],
        detectionControls: ['C-DET-003'],
        status: 'active',
        projectName: 'Aerator Pro',
        classification: 'CC',
        epochId: 17,
        notes: 'Strain relief added in iteration 5',
        changeHistory: [
            {
                timestamp: '2025-08-10T11:00:00Z',
                user: 'WK',
                field: 'Design Change',
                oldValue: 'No strain relief',
                newValue: 'Added molded strain relief',
                comment: 'Prevents flex fatigue at wire exit'
            },
            {
                timestamp: '2025-09-05T10:00:00Z',
                user: 'WK',
                field: 'O',
                oldValue: 4,
                newValue: 2,
                comment: 'Reduced after strain relief implementation'
            }
        ]
    },
    {
        id: 'FMEA-004',
        function: 'Electrical Distribution',
        itemFunction: 'Maintain battery connection',
        requirement: 'Constant contact pressure (>0.5N)',
        failureMode: 'Battery contacts corrode',
        effects: 'High resistance, voltage drop, power loss',
        S: 7,
        O: 4,
        D: 5,
        RPN: 140,
        preventionControls: ['C-PREV-004'],
        detectionControls: ['C-DET-004'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'Nickel plating prevents corrosion',
        changeHistory: [
            {
                timestamp: '2025-08-20T14:30:00Z',
                user: 'MC',
                field: 'Material',
                oldValue: 'Bare steel',
                newValue: 'Nickel-plated steel',
                comment: 'Added corrosion protection'
            }
        ]
    },
    {
        id: 'FMEA-005',
        function: 'Power Control',
        itemFunction: 'Open and close electrical circuit',
        requirement: 'Switch actuates reliably (>50,000 cycles)',
        failureMode: 'Switch mechanism jams or sticks',
        effects: 'User cannot turn frother on/off reliably',
        S: 7,
        O: 3,
        D: 2,
        RPN: 42,
        preventionControls: ['C-PREV-005'],
        detectionControls: ['C-DET-005'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'Qualified supplier with life test data',
        changeHistory: []
    },
    {
        id: 'FMEA-006',
        function: 'Power Control',
        itemFunction: 'Make/break electrical contact',
        requirement: 'Switch maintains low contact resistance',
        failureMode: 'Internal contacts wear out prematurely',
        effects: 'Intermittent or no power when switch actuated',
        S: 8,
        O: 2,
        D: 3,
        RPN: 48,
        preventionControls: ['C-PREV-005'],
        detectionControls: ['C-DET-003'],
        status: 'active',
        projectName: 'Aerator Pro',
        classification: 'CC',
        epochId: 17,
        notes: 'Gold-plated contacts for reliability',
        changeHistory: []
    },
    {
        id: 'FMEA-007',
        function: 'Power Control',
        itemFunction: 'Actuate switch mechanism',
        requirement: 'Smooth sliding motion with tactile feedback',
        failureMode: 'Switch cover detaches from housing',
        effects: 'Difficult to use, small parts hazard',
        S: 4,
        O: 3,
        D: 5,
        RPN: 60,
        preventionControls: ['C-PREV-001'],
        detectionControls: ['C-DET-002'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'Snap fit design validated',
        changeHistory: []
    },
    {
        id: 'FMEA-008',
        function: 'Sealing and Protection',
        itemFunction: 'Seal switch opening from environment',
        requirement: 'IPX4 splash resistance',
        failureMode: 'Switch gasket degrades over time',
        effects: 'Liquid ingress causes short circuit or corrosion',
        S: 9,
        O: 4,
        D: 6,
        RPN: 216,
        preventionControls: ['C-PREV-002'],
        detectionControls: ['C-DET-006'],
        status: 'active',
        projectName: 'Aerator Pro',
        classification: 'CC',
        epochId: 17,
        notes: 'Critical - requires TPE gasket material',
        changeHistory: [
            {
                timestamp: '2025-10-15T16:00:00Z',
                user: 'WK',
                field: 'Gasket Material',
                oldValue: 'Silicone',
                newValue: 'TPE',
                comment: 'Better compression set resistance'
            },
            {
                timestamp: '2025-11-01T09:30:00Z',
                user: 'JS',
                field: 'O',
                oldValue: 6,
                newValue: 4,
                comment: 'Improved after TPE gasket validation'
            },
            {
                timestamp: '2025-11-01T09:31:00Z',
                user: 'JS',
                field: 'RPN',
                oldValue: 324,
                newValue: 216,
                comment: 'RPN reduced via O reduction'
            }
        ]
    },
    {
        id: 'FMEA-009',
        function: 'Motor Performance',
        itemFunction: 'Generate sufficient torque',
        requirement: 'Motor provides >15,000 RPM under load',
        failureMode: 'Motor stalls when whisk immersed in liquid',
        effects: 'Poor frothing performance, customer dissatisfaction',
        S: 7,
        O: 3,
        D: 3,
        RPN: 63,
        preventionControls: ['C-PREV-006'],
        detectionControls: ['C-DET-007'],
        status: 'active',
        projectName: 'Aerator Pro',
        classification: 'SC',
        epochId: 17,
        notes: 'Brushless motor upgrade in iteration 12',
        changeHistory: [
            {
                timestamp: '2025-10-20T10:00:00Z',
                user: 'WK',
                field: 'Motor Type',
                oldValue: 'Brushed DC',
                newValue: 'Brushless DC',
                comment: 'Upgrade for higher power and reliability'
            },
            {
                timestamp: '2025-10-25T11:00:00Z',
                user: 'MC',
                field: 'O',
                oldValue: 5,
                newValue: 3,
                comment: 'Reduced stall risk with brushless motor'
            }
        ]
    },
    {
        id: 'FMEA-010',
        function: 'Motor Performance',
        itemFunction: 'Support motor shaft rotation',
        requirement: 'Low friction, long life (>100 hours)',
        failureMode: 'Motor bearing wears out prematurely',
        effects: 'Noise, vibration, increased friction, seizure',
        S: 8,
        O: 2,
        D: 4,
        RPN: 64,
        preventionControls: ['C-PREV-006'],
        detectionControls: ['C-DET-008'],
        status: 'active',
        projectName: 'Aerator Pro',
        classification: 'SC',
        epochId: 17,
        notes: 'Ceramic bearings specified for low noise',
        changeHistory: [
            {
                timestamp: '2025-10-22T13:00:00Z',
                user: 'WK',
                field: 'Bearing Type',
                oldValue: 'Steel ball bearing',
                newValue: 'Ceramic ball bearing',
                comment: 'Quieter operation, longer life'
            }
        ]
    },
    {
        id: 'FMEA-011',
        function: 'Motor Performance',
        itemFunction: 'Convert electrical to mechanical energy',
        requirement: 'Motor operates for >100 hours continuous',
        failureMode: 'Motor brushes wear out (N/A for brushless)',
        effects: 'Complete motor failure',
        S: 9,
        O: 1,
        D: 2,
        RPN: 18,
        preventionControls: ['C-PREV-006', 'C-PREV-007'],
        detectionControls: ['C-DET-008'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'Brushless motor eliminates this failure mode',
        changeHistory: [
            {
                timestamp: '2025-10-20T10:05:00Z',
                user: 'WK',
                field: 'O',
                oldValue: 4,
                newValue: 1,
                comment: 'Brushless motor has no brushes - failure mode eliminated'
            },
            {
                timestamp: '2025-10-20T10:06:00Z',
                user: 'WK',
                field: 'RPN',
                oldValue: 72,
                newValue: 18,
                comment: 'Major RPN reduction from brushless design'
            }
        ]
    },
    {
        id: 'FMEA-012',
        function: 'Shaft Train',
        itemFunction: 'Transmit torque without deformation',
        requirement: 'Shaft remains straight under load',
        failureMode: 'Shaft bends permanently',
        effects: 'Whisk wobbles, vibration, noise, poor performance',
        S: 6,
        O: 2,
        D: 5,
        RPN: 60,
        preventionControls: ['C-PREV-008'],
        detectionControls: ['C-DET-001'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: '304 stainless provides adequate stiffness',
        changeHistory: []
    },
    {
        id: 'FMEA-013',
        function: 'Shaft Train',
        itemFunction: 'Couple with motor output',
        requirement: 'Secure connection, no slippage',
        failureMode: 'Shaft slips in motor coupling',
        effects: 'Motor spins but whisk does not rotate',
        S: 8,
        O: 3,
        D: 6,
        RPN: 144,
        preventionControls: ['C-PREV-009'],
        detectionControls: ['C-DET-002'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'Press-fit coupling with inspection protocol',
        changeHistory: []
    },
    {
        id: 'FMEA-014',
        function: 'Frothing Performance',
        itemFunction: 'Agitate liquid to create foam',
        requirement: 'Whisk geometry optimized for aeration',
        failureMode: 'Whisk head deforms during use',
        effects: 'Reduced frothing efficiency, imbalance',
        S: 5,
        O: 3,
        D: 3,
        RPN: 45,
        preventionControls: ['C-PREV-008'],
        detectionControls: ['C-DET-009'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'Larger 35mm whisk improves performance',
        changeHistory: [
            {
                timestamp: '2025-11-05T14:00:00Z',
                user: 'WK',
                field: 'Whisk Diameter',
                oldValue: '25mm',
                newValue: '35mm',
                comment: 'Customer requirement for better aeration'
            }
        ]
    },
    {
        id: 'FMEA-015',
        function: 'Frothing Performance',
        itemFunction: 'Contact liquid safely',
        requirement: 'Food-safe, corrosion-resistant material',
        failureMode: 'Whisk material corrodes in liquid',
        effects: 'Liquid contamination, health hazard',
        S: 10,
        O: 2,
        D: 4,
        RPN: 80,
        preventionControls: ['C-PREV-008'],
        detectionControls: ['C-DET-004'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: '304 SS is FDA compliant, food-safe',
        changeHistory: []
    },
    {
        id: 'FMEA-016',
        function: 'Sealing and Protection',
        itemFunction: 'Seal rotating shaft from liquid',
        requirement: 'Prevent liquid ingress for >1000 uses',
        failureMode: 'Shaft seal leaks allowing liquid ingress',
        effects: 'Liquid enters motor compartment, failure',
        S: 9,
        O: 2,
        D: 6,
        RPN: 108,
        preventionControls: ['C-PREV-010'],
        detectionControls: ['C-DET-006'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'Dual seal design with Viton primary seal',
        changeHistory: [
            {
                timestamp: '2025-09-25T10:30:00Z',
                user: 'WK',
                field: 'Seal Material',
                oldValue: 'Silicone O-ring',
                newValue: 'Viton FKM O-ring',
                comment: 'Better high-temp resistance for hot liquids'
            },
            {
                timestamp: '2025-10-30T15:00:00Z',
                user: 'JS',
                field: 'Seal Design',
                oldValue: 'Single seal',
                newValue: 'Dual seal (Viton + NBR backup)',
                comment: 'Added redundancy for critical function'
            },
            {
                timestamp: '2025-11-01T09:00:00Z',
                user: 'WK',
                field: 'O',
                oldValue: 5,
                newValue: 2,
                comment: 'Dual seal reduces leak probability'
            },
            {
                timestamp: '2025-11-01T09:01:00Z',
                user: 'WK',
                field: 'RPN',
                oldValue: 270,
                newValue: 108,
                comment: 'Major RPN improvement from design iteration'
            }
        ]
    },
    {
        id: 'FMEA-020',
        function: 'Labeling and Compliance',
        itemFunction: 'Provide regulatory and product information',
        requirement: 'Label legible and permanent',
        failureMode: 'Label ink fades or peels off',
        effects: 'Loss of regulatory marks, branding, user info',
        S: 3,
        O: 2,
        D: 2,
        RPN: 12,
        preventionControls: ['C-PREV-011'],
        detectionControls: ['C-DET-010'],
        status: 'active',
        projectName: 'Aerator Pro',
        epochId: 17,
        notes: 'UV-resistant ink and adhesive',
        changeHistory: []
    }
];

// FMEA Iteration Summary
export const fmeaIterationHistory = {
    iteration1: { date: '2025-08-01', totalRPN: 1869, avgRPN: 110, highRiskCount: 8 },
    iteration5: { date: '2025-09-15', totalRPN: 1547, avgRPN: 91, highRiskCount: 6 },
    iteration12: { date: '2025-10-20', totalRPN: 982, avgRPN: 58, highRiskCount: 3 },
    iteration17: { date: '2025-12-12', totalRPN: 1289, avgRPN: 76, highRiskCount: 4 },
    totalReduction: '31% RPN reduction from iteration 1 to 17',
    keyImprovements: [
        'Brushless motor eliminated brush wear failure',
        'Dual seal design reduced leak risk by 60%',
        'Material upgrades reduced 5 distinct failure modes',
        'Design for manufacturing reduced occurrence scores'
    ]
};

export const fmeaSeedDataInfo = {
    totalItems: fmeaSeedData.length,
    totalChangeRecords: fmeaSeedData.reduce((sum, item) => sum + ((item.changeHistory?.length || 0)), 0),
    criticalFailures: fmeaSeedData.filter(f => f.S >= 9).length,
    highRPN: fmeaSeedData.filter(f => f.RPN >= 100).length,
    generatedDate: '2025-12-12',
    projectIteration: 17,
    reviewers: ['WK', 'JS', 'MC']
};
